import { useState } from 'react';

const StockTypeSwitcher = (props) => {
	const [graphType, setGraphType] = useState('Candle');
	const changeType = (value: string) => {
		setGraphType(value);
		document.dispatchEvent(new CustomEvent('GraphTypeChanged', { detail: { type: value } }));
	};
	return (
		<div className="flex align-middle justify-center md:justify-start gap-x-2 p-2">
			<select
				aria-label={'Chart Type'}
				defaultValue={'Candle'}
				onChange={(e) => changeType(e.target.value)}
				className="py-2 px-4 pe-9 w-full md:w-1/2 block bg-gray-100 border border-gray-500 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-gray-700 dark:border-transparent dark:text-gray-400 dark:focus:ring-gray-600"
			>
				<option>Candle</option>
				<option>Line</option>
				<option>OHLC</option>
			</select>
		</div>
	);
};

export default StockTypeSwitcher;
